<div class="totale container" [ngClass]="{'vedisx': toggle }">
     <div class="sinistra left">

        <mat-card class="ricerca">
            <mat-card-title>{{'Ricerca'|translate}}<a (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE5CD;</i></a></mat-card-title>
            <form >
                <mat-input-container>
                    <input [(ngModel)]="codice" name="codice" matInput placeholder="{{'Cerca per codice'|translate}}">
                </mat-input-container><br>
                <mat-input-container>
                    <input [(ngModel)]="descrizione" name="descrizione" matInput placeholder="{{'Cerca per descrizione'|translate}}">
                </mat-input-container><br>
                <mat-input-container>
                    <input [(ngModel)]="matricola"  name="matricola" matInput placeholder="{{'Cerca per matricola'|translate}}">
                </mat-input-container><br>
                <button mat-raised-button color="bottonebianco" (click)="cercaMacchine()">{{'Cerca'|translate}}</button>
            </form>
        </mat-card> 
        <br>
        <categoria-inline (onSelectCategoria)="onSelectCategoria($event)"></categoria-inline>
    </div>
    <div class="centro" style="min-height:500px;"><a mat-raised-button color="bianco" (click)="clickToggle()" class="aprisx"><i class="material-icons">&#xE8B6;</i></a>
        <nav>
            <ul class="nav-wrapper"  *ngIf="!ricerca">
                <li><a mat-raised-button color="primary" (click)="reset()">{{'MY g&w'|translate}}</a></li><li *ngFor="let m of navigazione"><span>&raquo;</span><a *ngIf="m.id!=categoriaCorrente.id" mat-raised-button color="primary" (click)="onSelectCategoria(m)">{{m.nome}}</a><a *ngIf="m.id==categoriaCorrente.id" mat-raised-button color="accent" (click)="onSelectCategoria(m)">{{m.nome}}</a></li>
            </ul>
            <ul class="nav-wrapper"  *ngIf="ricerca">
                <li><a mat-raised-button color="primary" (click)="reset()">{{'MY g&w'|translate}}</a></li><li><span>&raquo;</span><a mat-raised-button color="accent">{{'Risultati ricerca'|translate}}</a></li>
            </ul>
        </nav>
        <div class="corpo">
            <div class="risultati" *ngIf="ricerca">
                <span *ngIf="macchineTrovate.length<1">{{'Nessun risultato trovato'|translate}}</span>
            </div>
            <div *ngIf=" !ricerca" class="categorie">
                <categoria (onSelectCategoria)="onSelectCategoria($event)"></categoria>
            </div>

            <div *ngIf="macchineTrovate.length>0" class="macchine">
                <!--h4>Macchine</h4-->
                <div class="lista">
                    <div *ngFor="let m of macchineTrovate" class="card">
                        <mat-card >

                            <div class="content">
                                <mat-card-header>
                                    <mat-card-title>{{ m.nome }}</mat-card-title>
                                    <mat-card-subtitle>{{ m.descrizione }}</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>

                                    <a [routerLink]="['/scheda', m.id]"><div class="img bgfix" [ngStyle]="{'background-image': 'url(' + m.img + ')'}" >
                                         <!--img src="{{ m.img }}"-->
                                    </div></a>
                                <p class="codice">{{'Cod.'|translate}}<a [routerLink]="['/scheda', m.id]">{{ m.codice }}</a></p>
                            </mat-card-content>
                            <mat-card-actions class='destra'>
                                <button [routerLink]="['/scheda', m.id]" mat-raised-button color="bottonebianco" >{{'Scheda'|translate}}</button>
                            </mat-card-actions>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div></div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-macchine/tws-macchine.component.html